module.exports = __webpack_public_path__ + "img/tier2_pic3.63d78dc9.png";